import {getProductUrl} from 'modules/products/helpers';
import {ProductShort} from 'new-models';
import {useMemo} from 'react';

export const useProductUrl = (product?: Pick<ProductShort, 'id' | 'code'>) => {
    return useMemo<string>(() => {
        return getProductUrl(product);
    }, [product]);
};
